import { combineReducers } from 'redux'

import detail from './detail'
import list from './list'

const paymentReducers = combineReducers({
  list,
  detail,
})

export default paymentReducers
